import mustache from "mustache";
import { FertilizacionParseRequest } from "../../../../modulos/fertilizacion/request/FertilizacionParseRequest";
import { toISODate } from "../../../../utils/fechaUtils";
import { IFormBodyRender } from "../../../definitions/form/IFormBodyRender";
import { IFormField } from "../../../definitions/form/IFormField";
import { InputDateField } from "../../../implementations/form/date/InputDateField";
import { InputFileField } from "../../../implementations/form/file/InputFileField";
import template from "./fertilizacionCargaFormTemplate.html";

mustache.parse(template);

/** Formulario de carga de un análisis de laboratorio (Render/Connect): fecha del
 *  análisis + Excel de Agrilab (se sube al storage y viaja como `blobUrl` limpio).
 *  Expone `validate()` para el contenedor, que al validar dispara el parse. */
export class FertilizacionCargaFormRender implements IFormBodyRender {
  private readonly _request: FertilizacionParseRequest;
  private readonly _fecha: InputDateField<FertilizacionParseRequest>;
  private readonly _archivo: InputFileField<FertilizacionParseRequest>;

  /** Campos con validación (para `validate`). */
  private readonly _fields: IFormField[];

  constructor(request: FertilizacionParseRequest) {
    this._request = request;
    this._fecha = this._createFecha();
    this._archivo = this._createArchivo();
    this._fields = [this._fecha, this._archivo];
  }

  render(): string {
    return mustache.render(template, {
      fecha: this._fecha.render(),
      archivo: this._archivo.render(),
    });
  }

  connect(): void {
    this._fields.forEach((field) => field.connect());
  }

  dispose(): void {
    this._fields.forEach((field) => field.dispose());
  }

  /** Valida todos los campos; retorna `true` si son válidos. */
  validate(): boolean {
    let isValid = true;
    this._fields.forEach((field) => {
      field.showError();
      if (field.getError()) {
        if (isValid) field.focus();
        isValid = false;
      }
    });
    return isValid;
  }

  /** Fecha del análisis (máximo hoy). */
  private _createFecha(): InputDateField<FertilizacionParseRequest> {
    return new InputDateField(this._request, {
      label: "Fecha del análisis",
      description: "Fecha del muestreo / laboratorio",
      max: toISODate(new Date()),
      get: (r) => r.fechaAnalisis,
      set: (r, v) => {
        r.fechaAnalisis = v;
      },
    });
  }

  /** Excel de Agrilab (se sube al storage; requerido). */
  private _createArchivo(): InputFileField<FertilizacionParseRequest> {
    return new InputFileField(
      this._request,
      {
        label: "Archivo Excel — Agrilab",
        description: "ASU… (edáfico) · .xlsx",
        accept: ".xlsx,.xls",
        btnLabel: "Elegir Excel",
        get: (r) => r.blobUrl,
        set: (r, v) => {
          r.blobUrl = v;
        },
      },
      { isRequired: true },
    );
  }
}
